// The browser never talks to Supabase. Every read and write goes through the
// /api/* handlers holding the secret key, so no database credential ships here.

/**
 * Thin wrapper over the /api handlers. Sends cookies so staff/admin sessions
 * work, and surfaces the server's error text rather than a generic failure.
 */
export async function api(path, { method = "GET", body, params } = {}) {
  const qs = params ? `?${new URLSearchParams(params)}` : "";
  const res = await fetch(`/api/${path}${qs}`, {
    method,
    credentials: "same-origin",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try { data = await res.json(); } catch (e) { /* non-JSON error page */ }
  if (!res.ok || data.ok === false) {
    const err = new Error(data.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

/** Booked slot strings for one day. Asks for the whole day, never one block. */
export async function fetchBookedSlots(date) {
  if (!date) return [];
  try {
    const result = await api("availability", { params: { date } });
    return result.booked || [];
  } catch (error) {
    console.error("Error fetching booked slots:", error);
    return [];
  }
}
